import styles from './styles.less';
import { isFunction } from 'lodash';


class DFPAd extends React.Component {
    static propTypes = {
        adClassName: React.PropTypes.string,
        id: React.PropTypes.string.isRequired,
        type: React.PropTypes.oneOf(['bnr', 'rect'])
    };

    static defaultProps = {
        type: 'bnr'
    };

    render() {
        const className = cx(styles.dfp, this.props.className);
        const adClassName = cx('ad', `ad_${this.props.type}`, this.props.adClassName);
        return (
            <div
                className={ className }
                style={ this.props.style }>
                <div
                    className={ adClassName }
                    id={ this.props.id }>
                </div>
            </div>
        );
    }

    refreshAd = () => {
        if (window.AMPTManager && isFunction(window.AMPTManager.refreshAd)) {
            window.AMPTManager.refreshAd(this.props.id);
        }
    };
}


export default DFPAd;



/** WEBPACK FOOTER **
 ** ./src/common/components/ad/dfp.js
 **/